module.exports = __webpack_public_path__ + "static/event-trailer-for-field-evaluation-ca211aa67778049e3a3b3291e151261f.jpg";